<template>
  <div id="fy_intr" class="parent_container">
    <h2 class="text-center">无缝对接你的所有软件</h2>
    <h4 class="text-center">
      极其精简API接口对接服务，一天即可完成对接。一次对接，所有设备可用，省时省心省力。
    </h4>
    <fy_view_pdf :pdf-index="pdfIndex" class="fy_view"></fy_view_pdf>
  </div>
</template>

<script>
  import './../assets/css/fy_intr.css'
  import fy_view_pdf from "./fy_view_pdf"
    export default {
        name: "fy_intr",
        props: ['pdfIndex'],
        components: {
            fy_view_pdf
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_intr.vue